<div 
    class="agpr-socialLinksDisplay"
    [ngStyle]="{
        'background-color': data.styles.backgroundColor,
        'padding-top': data.styles.padding.paddingOption
                ? (data.styles.padding.topPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
        'padding-right': data.styles.padding.paddingOption
                ? (data.styles.padding.rightPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
        'padding-bottom': data.styles.padding.paddingOption
                ? (data.styles.padding.bottomPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
        'padding-left': data.styles.padding.paddingOption
                ? (data.styles.padding.leftPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px'
    }"
>
    <ul 
        class="agpr-socialLinksDisplay-list"
        [ngStyle]="{
            'display': 'flex',
            'flex-direction': data.styles.layoutOption === layoutOptionEnum.horizontal 
                ? 'row' 
                : 'column',
            'justify-content': data.styles.layoutOption === layoutOptionEnum.horizontal && data.styles.alignment === 'left' 
                ?  'flex-start'
                :  data.styles.layoutOption === layoutOptionEnum.horizontal && data.styles.alignment === 'right'
                ? 'flex-end'
                : 'center',
            'align-items': data.styles.layoutOption === layoutOptionEnum.vertical && data.styles.alignment === 'left'
                ?  'flex-start'
                :  data.styles.layoutOption === layoutOptionEnum.vertical && data.styles.alignment === 'right'
                ? 'flex-end'
                : 'center'
        }"
    >
        @for(link of data.links; track link) {
            <li class="agpr-socialLinksDisplay">
                @if (data.styles.displayOption === displayOption.iconAndLinkText
                    || data.styles.displayOption === displayOption.iconOnly
                ) {
                    <a  
                        [href]="link.url" 
                        target="_blank"
                    >
                        <img
                            [class]="'agpr-socialLinksDisplay-icon' + data.styles.iconSize"

                            [src]="data.styles.iconColor === 'light'
                                ? lightIconImagesMap.get(link.type)
                                : darkIconImagesMap.get(link.type)
                            "
                            [ngStyle]="{
                                'background-color': data.styles.iconBackgroundColor,
                                'border-radius': (data.styles.iconShape) + 'px',
                            }"
                        />
                    </a>
                }
                @if (data.styles.displayOption === displayOption.iconAndLinkText
                    || data.styles.displayOption === displayOption.linkTextOnly
                ) {
                    <a
                        class="agpr-socialLinksDisplay-text"
                        [href]="link.url" 
                        target="_blank"
                        [ngStyle]="{
                            'color': data.styles.color,
                            'text-decoration': data.styles.italics 
                                ? 'italic'
                                : data.styles.bold 
                                ? 'bold'
                                : 'underline'
                            ,
                            'font-family': data.styles.fontFamily,
                            'font-size': data.styles.fontSize,
                            'font-style': data.styles.italics ? 'italic' : 'normal',
                            'font-weight': data.styles.bold ? 'bold': 'normal',
                            'background-color': data.styles.backgroundColor 
                        }"
                        
                    >
                        @if (link.text) {
                            {{ link.text }}
                        }
                        @else {
                            {{ link.url }}
                        }
                    </a>
                }
            </li>
        }
    </ul>
  
</div>